var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"t-footer",style:(_vm.cssVariables)},[_c('span',{staticClass:"signature",domProps:{"innerHTML":_vm._s(_vm.$config.strings['footer-signature'])}}),_c('WoliLogo',{ref:"logo",staticClass:"logo"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }